import React, { Component } from "react";

import { markdownify } from "config/utils";

import { Wrapper, Inner, Title, Text, Icon } from "./styles";

class Accordion extends Component {
  state = {
    isVisible: false
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleVisibility, false);
  }

  componentWillUnmount() {
    document.addEventListener("mousedown", this.handleVisibility, false);
  }

  toggleVisiblity = event => {
    if (this.wrapper && this.wrapper.contains(event.target)) {
      this.setState(state => ({ isVisible: !state.isVisible }));
    }
  };

  handleVisibility = event => {
    if (this.wrapper && !this.wrapper.contains(event.target)) {
      this.setState({ isVisible: false });
    }
  };

  render() {
    const { isVisible } = this.state;
    const { content, size } = this.props;

    return (
      <Wrapper
        ref={ref => (this.wrapper = ref)}
        onClick={this.toggleVisiblity}
        size={size}
      >
        <Icon
          icon={isVisible ? "minus" : "plus"}
          isVisible={isVisible}
          size={size}
        />
        <Inner>
          <Title isVisible={isVisible} size={size}>
            {content.title}
          </Title>
          <Text
            size={size}
            isVisible={isVisible}
            dangerouslySetInnerHTML={{ __html: markdownify(content.text) }}
          />
        </Inner>
      </Wrapper>
    );
  }
}

export default Accordion;
